import { render, staticRenderFns } from "./BuyCertificate.vue?vue&type=template&id=d0b5b62c&scoped=true"
import script from "./BuyCertificate.vue?vue&type=script&lang=js"
export * from "./BuyCertificate.vue?vue&type=script&lang=js"
import style0 from "./BuyCertificate.vue?vue&type=style&index=0&id=d0b5b62c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0b5b62c",
  null
  
)

export default component.exports